// import React, { useEffect } from "react";
// import api from "../Axios/api";
//  (async function (){
// 	let pal = {
// 		palette: {
// 			primary: {
// 			  light: "#f44336",
// 			  main: "#EF233C",
// 			  dark:"#d32f2f",
// 			  contrastText: '#ffffff'
// 			},
// 			secondary: {
// 			  light: "#D3D3D3",
// 			  main: "#212121",
// 			  dark: "#212121",
// 			  contrastText: '#aaaaaa'
// 			},
// 			type: "light",
// 		},
// 		breakpoints: {
// 			values: {
// 			  xs: 0,
// 			  sm: 450,
// 			  md: 960,
// 			  xmd: 800,
// 			  lg: 1100,
// 			  xl: 1200,
// 			  xxl: 1250
// 			},
// 		},
// 		padding:{
// 			left: 13,
// 			right: 13
// 		}
// 	}
// 	let colors = null
// 	await api
// 	.get("/buyer/buyerPanel/colours", {})
// 	.then(function (res) {
// 	  colors = res.data.data
// 	  console.log("colors", colors)
// 	})
// 	.catch((error) =>
// 	  console.log("error in getting colors: ", error)
// 	);
// 	if(colors){
// 		pal.palette.primary.main = colors.primary.main
// 		pal.palette.primary.dark = colors.primary.dark
// 		pal.palette.primary.light = colors.primary.light
// 	}
// 	console.log("pallete inside", pal)
// 	return pal;
// }
// const pal = pallete()
// console.log("pal",pal)
//  )();

// export default pal;
// // const temp = Pallete().then(function(res) {
// //     console.log("pal", res)
// // 	return res;
// // })
// // console.log(temp)
// // light: "#ea80fc",
// // 		  main: "#7d2ae8",
// // 		  dark: "#6F22DA",
// // 		  contrastText: '#ffffff'


// const primary = "#090071";
// const secondary = "#FF5C93";
// const warning = "#FFC260";
// const success = "#3CD4A0";
// const info = "#9013FE";

var mode = localStorage.getItem("THEME_MODE");

// light: "#ea80fc",
// 		  main: "#7d2ae8",
// 		  dark: "#6F22DA",
// 		  contrastText: '#ffffff'
const pal = {
	palette: {
		primary: {
		  light: "#f44336",
		  main: "#EF233C",
		  dark: "#d32f2f",
		  contrastText: '#ffffff'
		},
		secondary: {
		  light: "#D3D3D3",
		  main: "#212121",
		  dark: "#212121",
		  contrastText: '#aaaaaa'
		},
		type: mode ? mode : "light",
	},
	breakpoints: {
		values: {
		  xs: 0,
		  sm: 450,
		  md: 960,
		  xmd: 800,
		  lg: 1100,
		  xl: 1200,
		  xxl: 1250
		},
	},
	padding:{
		left: 13,
		right: 13
	}
};

export default pal;

